import CommonModal from "../../../App/commonModal"
import React, { useEffect, useState } from "react";
import { Context,Hooks,Util,Request } from "@xt/xtbase";
import {get_profileInvitees, delete_profileInvitee} from "@/api/referral";
import { Table, Radio, Modal } from "antd";
import { ExclamationCircleFilled } from '@ant-design/icons';
import { useIntl, FormattedMessage } from "react-intl";
import CopyPagination from "../../../App/copyPagination"
import {get_commissionInvitees, get_commissionList, get_commissionBackList, get_commissionListExport, get_commissionBackListExport} from "@/api/referral";
import { saveFileFromBlob } from 'utils/method';

const {useTranslation, useDocumentWidth} = Hooks;
const {getOrigin, getUrl, title} = Util;
const { confirm } = Modal;
const {XtContext,XtAuth} = Context;

function ExportModal (props) {
  const { isShowModal, onClose, columns, title, index, activeIndex, activeIndex1 } = props;
  const t = useTranslation();
  const [appState] = React.useContext(XtContext);
  const {loginStatus, lang} = appState;
  const [value, setValue] = useState(7);
  const [hasPrev, setHasPrev] = useState(false)
  const [hasNext, setHasNext] = useState(false)
  const [dataSource, setDataSource] = useState([])

  const onChange = (e) => {
    getDataSource(undefined, undefined, e.target.value)
    setValue(e.target.value);
  };

  const onPrev = () => {
    const fromId = commissionInvitees[0]?.id;

    const direction = 'PREV';
    if (fromId) {
      getDataSource(direction, fromId);
    }
  };

  const onNext = () => {
    const direction = 'NEXT';
    const fromId = commissionInvitees[commissionInvitees.length - 1]?.id;

    if (fromId) {
      getDataSource(direction, fromId);
    }
  };

  useEffect(()=>{
    setValue(7)
    const getData = async() => {
      getDataSource(undefined, undefined, 7)
    }
    getData()
  }, [index])

  const getDataSource = async(direction, fromId, days=value) => {
    let dataSource = {
      items: [],
      hasNext: false,
      hasPrev: false
    }
    if (index == 1) {
      dataSource = await get_commissionInvitees({
        params: {
          limit: 5,
          direction,
          fromId,
          days
        }
      })
    } else if (index == 2) {
      let bizType = ''
      if (activeIndex == 1) {
        bizType = ''
      } else if (activeIndex == 2) {
        bizType = 'SPOT'
      } else if (activeIndex == 3) {
        bizType = 'FUTURES'
      } 
      dataSource = await get_commissionList({
        params: {
          limit: 5,
          bizType: bizType ? bizType : undefined,
          direction,
          fromId,
          days
        }
      })
    } else if (index == 3) {
      let bizType = ''
      if (activeIndex1 == 1) {
        bizType = ''
      } else if (activeIndex1 == 2) {
        bizType = 'SPOT'
      } else if (activeIndex1 == 3) {
        bizType = 'FUTURES'
      } 
      dataSource = await get_commissionBackList({
        params: {
          limit: 5,
          bizType: bizType ? bizType : undefined,
          direction,
          fromId,
          days
        }
      })
    }
    
    setDataSource(dataSource?.items || []);
    setHasNext(dataSource?.hasNext || false)
    setHasPrev(dataSource?.hasPrev || false)
  }

  const onExportSaveClick = () => {
    if (dataSource?.length == 0) return
    if (index == 2) {
      let bizType = ''
      if (activeIndex == 1) {
        bizType = ''
      } else if (activeIndex == 2) {
        bizType = 'SPOT'
      } else if (activeIndex == 3) {
        bizType = 'FUTURES'
      } 
      let params = {
        days: value,
        bizType: bizType ? bizType : undefined,
        // lang: lang == 'zh-CN' ? 'cn' : lang
      };
      get_commissionListExport({
        isReturnResponse: true,
        responseType: 'blob',
        headers: {
          Accept: 'application/vnd.ms-excel',
        },
        params,
      })
        .then(res => {
          saveFileFromBlob(res, `${t('home.earnings1')}.xlsx`);
        })
        .finally(() => {
          // 
        });
    } else if (index == 3) {
      let bizType = ''
      if (activeIndex1 == 1) {
        bizType = ''
      } else if (activeIndex1 == 2) {
        bizType = 'SPOT'
      } else if (activeIndex1 == 3) {
        bizType = 'FUTURES'
      } 
      let params = {
        days: value,
        bizType: bizType ? bizType : undefined,
        // lang: lang == 'zh-CN' ? 'cn' : lang
      };
      get_commissionBackListExport({
        isReturnResponse: true,
        responseType: 'blob',
        headers: {
          Accept: 'application/vnd.ms-excel',
        },
        params,
      })
        .then(res => {
          saveFileFromBlob(res, `${t('home.earnings2')}.xlsx`);
        })
        .finally(() => {
          // 
        });
    }
    
  };

  return(
    <>
      <CommonModal width={1000} title={title} isShowModal={isShowModal} onClose={onClose}>
        <div className="ExportModal">
          <div className="timeRange">{t("home.selectTimeRange")}</div>
          <div className="days"> 
            <Radio.Group onChange={onChange} value={value}>
              <Radio value={7}>{t("home.last7Days")}</Radio>
              <Radio value={30}>{t("home.last30Days")}</Radio>
            </Radio.Group>
          </div>
          <div className="export">
            <div className={`${dataSource?.length == 0 ? 'exportButtonDis': 'exportButton'}`} onClick={onExportSaveClick}>{t("home.export")}</div>
          </div>
          <div className="generateList">{t("home.generateList")}</div>
          <Table pagination={false} size="small" dataSource={dataSource} columns={columns} />
          {dataSource.length != 0 && <div className="pagination">
            <CopyPagination
              position="center"
              hasPrev={hasPrev}
              hasNext={hasNext}
              onPrev={onPrev}
              onNext={onNext}
              isActivePage={true}
            />
          </div>}
          <div className="exportTip">
            <div>{t("home.exportModalTip1")}</div>
            <div>{t("home.exportModalTip2")}</div>
            <div>{t("home.exportModalTip3")}</div>
          </div>
        </div>
      </CommonModal>
    </>
  )
}

export default ExportModal;